import React, { useState, useEffect } from "react";
import "./loadingScreen.css";
import charamyLogo from "../../images/charamylogo.jfif";

const LoadingScreen = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setIsComplete(true);
          setTimeout(() => {
            if (onComplete) onComplete();
          }, 500);
          return 100;
        }
        const increment = prev < 50 ? 2.5 : prev < 80 ? 1.8 : 1;
        return Math.min(prev + increment, 100);
      });
    }, 40);

    return () => clearInterval(interval);
  }, [onComplete]);

  const radius = 50;
  const circumference = 2 * Math.PI * radius;
  const dashoffset = circumference - (progress / 100) * circumference;

  if (isComplete) return null;

  return (
    <div className="loading-screen">
      <div className="loading-content">

        {/* ── LOGO with spinning rings ── */}
        <div className="loading-icon-container">
          {/* 
            logo-circle-clip = a div with border-radius:50% + overflow:hidden
            This is a hard circle mask — no grey border, no blend-mode weirdness.
            background:#06030f matches the page bg so black logo corners disappear.
          */}
          <div className="logo-circle-clip">
            <img
              src={charamyLogo}
              alt="Charamy"
              className="loading-logo"
            />
          </div>
        </div>

        {/* ── PROGRESS RING ── */}
        <div className="loading-progress">
          <div className="progress-ring">
            <svg
              className="progress-ring-svg"
              width="120"
              height="120"
              viewBox="0 0 120 120"
            >
              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%"   stopColor="#c084fc" />
                  <stop offset="50%"  stopColor="#7c3aed" />
                  <stop offset="100%" stopColor="#4c1d95" />
                </linearGradient>
              </defs>
              <circle
                className="progress-ring-bg"
                cx="60" cy="60" r={radius}
                fill="none" strokeWidth="4"
              />
              <circle
                className="progress-ring-fill"
                cx="60" cy="60" r={radius}
                fill="none" strokeWidth="4"
                strokeDasharray={circumference}
                strokeDashoffset={dashoffset}
              />
            </svg>
            <span className="progress-text">{Math.round(progress)}%</span>
          </div>

          <div className="loading-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>

          <div className="brand-text">Charamy.org</div>
        </div>

      </div>
    </div>
  );
};

export default LoadingScreen;